import App from "App"
import "index.scss"
import React from "react"
import ReactDOM from "react-dom"
import { Provider } from "react-redux"
import { store } from "store/store"

// Initialize languages
import "locales/i18n"
import { MsalProvider } from "@azure/msal-react"
import { msalInstance } from "./lib/msal"

ReactDOM.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <Provider store={store}>
        <App />
      </Provider>
    </MsalProvider>
  </React.StrictMode>,
  document.getElementById("root"),
)
